namespace Matrix.Data {
    export class SecurityTypeColumns {
        static columnsKey = 'Data.SecurityType';
    }
}
